import cn from 'classnames'
import {FC, ReactNode} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {PricingIncludedBenefits} from './PricingIncludedBenefits'

type PricingTableLayoutProps = {
  title?: string
  subtitle?: string | ReactNode
  benefitsTitle?: string
  benefits?: string[]
  note?: string
  fullWidth?: boolean
}

export const PricingTableLayout: FC<React.PropsWithChildren<PricingTableLayoutProps>> = ({
  title,
  subtitle,
  benefitsTitle,
  benefits,
  note,
  fullWidth = false,
  children,
}) => {
  return (
    <>
      {title && (
        <Text variant={TextVariant.h2} align="center">
          {title}
        </Text>
      )}
      {subtitle && <div className="subtitle">{subtitle}</div>}
      <div className={cn('wrapper', fullWidth && 'full-width')}>
        {benefitsTitle && benefits ? (
          <>
            <div className="content">{children}</div>
            <PricingIncludedBenefits {...{benefitsTitle, benefits, fullWidth}} />
          </>
        ) : (
          children
        )}
      </div>
      {note && (
        <div className="note">
          <Text variant={TextVariant.text14} color={theme.palette.text.light} align="center">
            {note}
          </Text>
        </div>
      )}

      <style jsx>{`
        .wrapper {
          display: flex;
          align-items: center;
          flex-direction: row-reverse;
          margin-top: ${theme.spacing[6]};
        }
        .content {
          position: relative;
          flex: 1;
          margin-left: -${theme.spacing[9]};
          background-color: ${theme.palette.background.default};
          border: 1px solid ${theme.palette.gray[200]};
          border-radius: 16px;
        }
        .note {
          margin-top: ${theme.spacing[5]};
        }
        .full-width {
          display: block;
        }
        .full-width .content {
          margin-left: 0;
        }
        .subtitle {
          max-width: 500px;
          margin: ${theme.spacing[5]} auto 0;
        }
        @media ${TABLET_SCREENSIZE} {
          .wrapper {
            display: block;
          }
          .content {
            margin-left: 0;
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .wrapper {
            margin-top: ${theme.spacing[5]};
          }
          .content {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
          }
          .note {
            margin-top: ${theme.spacing[4]};
          }
        }
      `}</style>
    </>
  )
}
